import component from "./ModalWrapper";
export default component;
